export default __webpack_public_path__ + "static/media/facebook-square-brands.38c6b4e5.svg";